const subscriptions = {};

const pubSub = {
    subscribe: (name, callback, subscriberId) => {
        if (!name) {
            throw new Error('name of action must be provided');
        }

        if (!callback || typeof callback !== 'function') {
            throw new Error('subscriber callback must be provided and must be a function');
        }

        if (!subscriberId) {
            throw new Error('subscriber Id has to be provided');
        }

        // TODO: Fix linting error
        // eslint-disable-next-line no-prototype-builtins
        if (!subscriptions.hasOwnProperty(name)) {
            subscriptions[name] = [];
        }

        subscriptions[name].push({
            id: subscriberId,
            callback
        });
    },
    unsubscribe: (id) => {
        Object.values(subscriptions).forEach((subscriptionMembers) => {
            subscriptionMembers.forEach((subscriptionMember, index) => {
                if (subscriptionMember.id === id) {
                    subscriptionMembers.splice(index, 1);
                }
            });
        });
    },
    dispatch: (name, payload) => {
        // TODO: Fix linting error
        // eslint-disable-next-line no-prototype-builtins
        if (subscriptions.hasOwnProperty(name)) {
            subscriptions[name].forEach((subscription) => subscription.callback(payload));
        }
    }
};

export default pubSub;
